// Colour-coded picklist swatches mirroring Zoho's own colour coding
export const PRODUCT_COLOURS = {
  'partitioning': '#3b82f6',
  'drywall': '#f59e0b',
  'drylining': '#f59e0b',
  'dry lining': '#f59e0b',
  'ceilings': '#10b981',
  'suspended ceilings': '#10b981',
  'passive fire protection': '#ef4444',
  'fire protection': '#ef4444',
  'insulation': '#ec4899',
  'technical insulation': '#0ea5e9',
  'other': '#6b7280',
  'construction products': '#8b5cf6',
  'accessories': '#14b8a6',
  'plastering': '#f97316',
  'screed': '#a16207',
  'flooring': '#14b8a6',
  'roofing': '#0284c7',
  'glazing': '#6366f1',
  'steelwork': '#475569',
  'groundworks': '#78716c',
  'mechanical': '#dc2626',
  'electrical': '#ca8a04',
  'main contractor': '#7c3aed',
  'sub contractor': '#059669',
};

export const productColour = (name) =>
  PRODUCT_COLOURS[(name || '').trim().toLowerCase()] || '#9ca3af';

export const ColourDot = ({ color }) => (
  <span
    className="inline-block w-2.5 h-2.5 rounded-full mr-2 align-middle ring-1 ring-black/10"
    style={{ backgroundColor: color || '#9ca3af' }}
    aria-hidden
  />
);

// Shared input style for all form fields inside this modal
export const INPUT_CLS = 'bg-white border-2 border-gray-300 rounded-xl';

// Normalises a customer name parsed from a PDF for Zoho search
export const normalizeSearchQuery = (name) => {
  if (!name) return '';
  return name
    .replace(/\s*&\s*/g, '&')
    .replace(/\(\d+\)/g, '')
    .replace(/\(([A-Z][^)]+)\)/gi, ' $1')
    .replace(/\s+/g, ' ')
    .trim();
};
